<template>
  <div class="card shadow bb-card mb-3">
    <div class="card-body rounded m-3">
      <div class="row">
        <!-- first col -->
        <div class="col-sm-5">
          <img
            v-bind:src="arena.image"
            class="card-img-top float-center rounded img-fluid bb-image-container"
            height="200px"
            alt="Campaign Image"
          />
          <div class="card-block mt-3">
            <div class="bb-hdg bb-campaign-name mb-3">
              <!-- only allow editing if dm = user -->
              <router-link
                v-if="isCurrentUserDm"
                :to="{ name: 'campaignSetup', params: { slug: arena.slug } }"
                class="bb-link"
              >
                {{ arena.name }}
              </router-link>
              <p v-else>{{ arena.name }}</p>
            </div>

            <p class="card-text mb-4 bb-text">
              {{ arena.description }}
            </p>
          </div>
        </div>

        <!-- blank middle col -->
        <div class="col-1"></div>

        <!-- RHS col -->
        <div class="col">
          <div class="row align-items-center">
            <p class="bb-sub-hdg bb-campaign-meta-label">DM</p>
          </div>

          <div class="row align-items-center">
            <div class="col-7 bb-text">
              <label>{{ dmUserName }}</label>
            </div>
            <!-- src="//placehold.it/70x70" -->
            <div class="col text-end">
              <img
                v-bind:src="dmAvatarImage"
                height="70"
                width="70"
                class="rounded-circle border border-dark bb-image-container"
                alt="DM Avatar"
              />
            </div>
          </div>

          <div class="row mt-2 align-items-center">
            <p class="bb-sub-hdg bb-campaign-meta-label">Enrolled Players:</p>
          </div>
          <div v-if="campaignPlayers.length == 0">
            <p class="bb-text">No Players Enrolled</p>
          </div>

          <div
            v-for="player in campaignPlayers"
            :key="player.id"
          >
            <CampaignCardPlayerComponent :player="player" />
          </div>
        </div>
      </div>
      <!-- last row -->
      <div class="row mb-1 mt-3">
        <!-- ---------------------------- -->
        <!--   join combat (player only)  -->
        <!-- ---------------------------- -->
        <div v-if="isCurrentUserPlayer && !isCurrentUserDm">
          <!-- ---------- -->
          <!--   locked   -->
          <!-- ---------- -->
          <div v-if="arena.locked">
            <button
              :disabled="arena.locked"
              class="btn btn-lg btn-primary me-3"
              style="width: 45%"
            >
              <img
                :src="lockArenaImg"
                style="float: right; margin-right: 0.5em"
              />
              Join
            </button>
          </div>
          <!-- ------------ -->
          <!--   unlocked   -->
          <!-- ------------ -->
          <div v-if="!arena.locked">
            <button
              class="btn btn-lg btn-primary me-3"
              @click="
                $router.push({
                  name: 'playerCombat',
                  params: { slug: arena.slug },
                })
              "
              style="width: 45%"
            >
              Join Combat
            </button>
          </div>
        </div>
        <!-- ------------------------- -->
        <!--  manage combat (dm only)  -->
        <!-- ------------------------- -->
        <button
          v-if="isCurrentUserDm"
          class="btn btn-lg btn-primary"
          @click="manageCombat()"
          style="width: 50%"
        >
          Manage Combat
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignCardPlayerComponent from '@/components/CampaignCardPlayer.vue'
import store from '../store/index'
import lockArenaImg from '../assets/images/bbLockArena.png'

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CampaignCardComponent',
  //========================================
  // component
  //-----------
  components: {
    CampaignCardPlayerComponent,
  },
  //========================================
  // props
  //-------
  props: {
    arena: {
      type: Object,
      required: true,
    },
  },
  //========================================
  // data
  //------
  data() {
    return {
      lockArenaImg,
    }
  },
  //========================================
  // computed
  //----------
  computed: {
    ...mapGetters('auth', {
      getUserProfile: 'getUserProfile',
    }),
    arena_id() {
      return this.arena.id
    },
    arenaDm() {
      return this.arena?.dm || null
    },
    dmUserName() {
      return this.arenaDm?.user_name || 'Unassigned'
    },
    dmAvatarImage() {
      return this.arenaDm?.avatar_image || this.arena?.image || ''
    },
    campaignPlayers() {
      return Array.isArray(this.arena?.players) ? this.arena.players : []
    },
    isCurrentUserPlayer() {
      const currentUserName = this.getUserProfile?.user_name
      const currentUserEmail = this.getUserProfile?.email

      return this.campaignPlayers.some(
        (player) =>
          (currentUserName && player?.user_name === currentUserName) ||
          (currentUserEmail && player?.email === currentUserEmail),
      )
    },
    isCurrentUserDm() {
      const currentUserName = this.getUserProfile?.user_name
      const dmUserName = this.arenaDm?.user_name
      return Boolean(
        currentUserName && dmUserName && dmUserName === currentUserName,
      )
    },
  },
  //========================================
  // methods
  //---------
  methods: {
    ...mapMutations('combat', {
      setArena: 'setArena',
    }),
    manageCombat() {
      // store selected arena
      store.commit('combat/setArena', this.arena)
      // route to arena
      this.$router.push({
        name: 'manageCombat',
        params: { slug: this.arena.slug },
      })
    },
  },
}
</script>

<style scoped>
.bb-campaign-name {
  font-size: 2vw;
}

.bb-campaign-meta-label {
  font-size: 1.7vw;
}

.btn-lg {
  font-size: 30px !important;
}

.btn.btn-primary[disabled] {
  background-color: #737373 !important;
  color: white !important;
  border-color: grey !important;
  opacity: 1 !important;
}
</style>
